import common from './components/common';
import AOS from 'aos';
import LatestRaceWidget from './components/latest-race-widget';
import LatestRaceResults from './components/latest-race-results';
import PointsSummary from './components/points-summary';
import eventPage from './components/event-page';
import sliders from './components/sliders';
import countdown from './components/countdown';
import mobileMenu from './components/mobile-menu';
import eventsFilters from './components/events-filters';
import accordion from './components/accordion';
import HeatByHeatHome from './components/heat-by-heat/hbh-home';
import HeatByHeatResults from './components/heat-by-heat/hbh-results';
import HeatByHeatBestLap from './components/heat-by-heat/hbh-best-lap';
import HeatByHeatIndividualLap from './components/heat-by-heat/hbh-individual-lap';
import HeatByHeatBestSegment from './components/heat-by-heat/hbh-best-segment';
import HeatByHeatIndividualSegment from './components/heat-by-heat/hbh-individual-segment';
import PointsSummaryPlayoff from './components/points-summary-playoff';
import HeatByHeatSessionResults from './components/heat-by-heat/hbh-session-results';
import eventDetailSchedule from './components/event-schedule';
import HeatByHeatStartingLineup from './components/heat-by-heat/hbh-starting-lineup';
import HeatByHeatRiderPoints from './components/heat-by-heat/hbh_rider-points';
import HeatByHeatRiderPointsPos from './components/heat-by-heat/hbh_rider-points-pos';
import HeatByHeatOverall from './components/heat-by-heat/hbh-overall';
import HeatByHeatCombinedQualifying from './components/heat-by-heat/hbh-combined-qualifying';
import '../../node_modules/magnific-popup/dist/jquery.magnific-popup';


jQuery( document ).ready(function($) {

  common();

  // Accordion
  $('.accordion .item').click(function(e){
    $(this).find('.title').toggleClass('active');
    $(this).find('.content').slideToggle();
    e.stopImmediatePropagation();
  });

  // Animations
  AOS.init({ duration: 500, once: true, });

  // Hide schedule mobile bar
  $('.button-wrapper .close').click(function(){
    $('.button-wrapper').addClass('hide')
  })

  $('.race-trigger').click(function(){
    $(this).addClass('active')
    $('.race-trigger').not(this).removeClass('active')
    const target = $(this).attr('data-target')
    console.log(target)
    $(`#${target}`).addClass('active');
    $('.race-home-results').not(`#${target}`).removeClass('active')
  })

  const locationCountry = $('body').attr('data-country')
  if(locationCountry !== 'US'){
    $('.us-only').removeClass('active')
    $('.not-us-only').addClass('active')
    $('.hide-on-int-if-not-available').hide()
    console.log('not us')
  } else{
    $('.us-only').addClass('active')
    $('.not-us-only').removeClass('active')
    console.log('us')
  }


  // accordion()
  $('.accordion-alt .item').click(function(e){
    $(this).find('.title').toggleClass('active')
    $(this).find('.content').toggleClass('active')
    e.stopImmediatePropagation()
  })
  eventPage()
  mobileMenu()

  LatestRaceWidget()
  LatestRaceResults()
  PointsSummary()
  PointsSummaryPlayoff()

  HeatByHeatHome()
  HeatByHeatResults()
  HeatByHeatSessionResults()
  HeatByHeatBestLap()
  HeatByHeatIndividualLap()
  HeatByHeatBestSegment()
  HeatByHeatIndividualSegment()
  HeatByHeatStartingLineup()
  HeatByHeatRiderPoints()
  HeatByHeatRiderPointsPos()
  HeatByHeatOverall()
  HeatByHeatCombinedQualifying()

  $('.wp-block-gallery').magnificPopup({
    delegate: 'a',
    type: 'image',
    gallery: {
      enabled: true
    },
    image: {
      titleSrc: function(item) {
         return item.el.find('img').attr('title');
      }
    }
  });
  

  $('.track-image').magnificPopup({
    type: 'image'
    // other options
  });


  $('.wp-block-image').each(function( index ) {
    const image = $(this).find('img')
    const caption = $(this).find('.wp-element-caption').html()
    image.attr('title', caption)
  })


  $('.menu-item-has-children').append(`<button class="toggle-submenu"><i class="fas fa-chevron-down"></i></button>`)

  $('.toggle-submenu').click(function(){
    $(this).toggleClass('active')
    $(this).parent().find('.sub-menu').slideToggle()
  })

  eventDetailSchedule()
  sliders()
  countdown()
  eventsFilters()

  $('.all-rider-photo').click(function(e){
    e.preventDefault()
    $(this).parent().toggleClass('all')
    if($(this).html() === 'Load More'){
      $(this).html('View Less')
    }else{
      $(this).html('Load More')
    }
  });

  $('.il-view-all').click(function(){
    if($(this).html() === 'view more'){
      $(this).html('view less')
    }else{
      $(this).html('view more')
    }
    $(this).parent().toggleClass('active')
  })

  $('.bs-view-all').click(function(){
    if($(this).html() === 'view more'){
      $(this).html('view less')
    }else{
      $(this).html('view more')
    }
    $(this).parent().toggleClass('active')
  })

  function acc() {
    $('.smx-acc .smx-acc-item .smx-acc-trigger').click(function(){
      $(this).parent().find('.smx-acc-content').toggleClass('active')
      $(this).find('i').toggleClass('active')
    })
  }
  acc()



  //restricted blocks
  const currentLanguage = $('body').data('country')
  $('.restricted-block').each(function(){
    const restrictedTo = $(this).data('block-languages')
    if (!restrictedTo.includes(currentLanguage)) {
      $(this).hide()
    }
  })

  // Scroll to anchor
	const urlParams = new URLSearchParams(window.location.search);
  const anchor = urlParams.get('section');
  if (anchor) {
    const element = document.getElementById(anchor);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }


});